import { memo, useContext } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { Sparkles } from 'lucide-react'
import { ExecutionContext } from '../../../components/flow-nodes/shared/ExecutionContext'

// Handle 样式常量
const HANDLE_STYLE = {
  width: 12,
  height: 12,
  background: '#94a3b8',
  border: '2px solid white',
} as const

const HANDLE_STYLE_ACTIVE = {
  ...HANDLE_STYLE,
  background: '#3b82f6',
} as const

// v11.3 新增：Structured Agent 节点（真正的 Agent Loop + 结构化 Prompt）
export const StructuredAgentNode = memo(({ data, selected, id }: NodeProps) => {
  const { activeNodeId, visitedNodeIds } = useContext(ExecutionContext)
  const isActive = activeNodeId === id
  const isVisited = visitedNodeIds.has(id)
  
  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-teal-50 border-2 min-w-[180px] transition-all duration-300 ${
      isActive 
        ? 'border-teal-500 ring-4 ring-teal-400/50 shadow-xl scale-105 animate-pulse' 
        : selected 
          ? 'border-teal-500 ring-2 ring-teal-500/20 shadow-xl' 
          : isVisited 
            ? 'border-teal-300 ring-2 ring-teal-200/50' 
            : 'border-teal-200'
    }`}>
      <Handle
        type="target"
        position={Position.Left}
        style={selected || isActive ? { ...HANDLE_STYLE_ACTIVE, background: '#14b8a6' } : { ...HANDLE_STYLE, background: '#14b8a6' }}
      />
      
      <div className="flex items-center gap-2">
        <div className={`p-1.5 rounded-md transition-colors duration-300 ${isActive ? 'bg-teal-500' : 'bg-teal-100'}`}>
          <Sparkles className={`h-4 w-4 ${isActive ? 'text-white' : 'text-teal-600'}`} />
        </div>
        <div>
          <div className="font-medium text-sm text-teal-900">{data.label}</div>
          <div className="text-xs text-teal-600 flex items-center gap-1">
            <span>🔄</span>
            <span>Agent Loop</span>
          </div>
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Right}
        style={selected || isActive ? { ...HANDLE_STYLE_ACTIVE, background: '#14b8a6' } : { ...HANDLE_STYLE, background: '#14b8a6' }}
      />
    </div>
  )
})

StructuredAgentNode.displayName = 'StructuredAgentNode'